import React, { useState } from "react";
import Appointment from "../assets/appointment.png"; // Ensure this image is in the correct path
import FloatingPhone from "./appointmentComponent/floatingPhone";
import { AnimatePresence, motion } from "framer-motion";
import AppointmentForm from "./appointment";

const AppointmentAndAppDownload = () => {
  const [showModal, setShowModal] = useState(false);

  const handleToggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <section className="bg-[#d2e4f2] py-1 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          {/* Appointment Section */}
          <div className="flex flex-col items-center text-center md:text-left">
            <img
              src={Appointment}
              alt="appointment"
              className="max-w-xs mb-4 h-full"
            />
            <h2 className="text-2xl md:text-3xl font-bold text-dark mb-2">
              Schedule Your Appointment Today
            </h2>
            <p className="text-lg font-semibold text-primary mb-2">
              Call : 956-047-9500
            </p>
            <p className="text-secondary max-w-md mb-4">
              Experience an easy way to connect with our professional logistic
              experts and get best deals instantly on services like packers and
              movers, car transportation, cargo, transport and warehouse.
            </p>
            <button
              onClick={handleToggleModal}
              className="bg-primary hover:bg-accent transition px-6 py-2 rounded text-white text-lg font-medium mb-4"
            >
              Get Quotes
            </button>
          </div>

          {/* App Download Section */}
          <div className="flex flex-col items-center text-center md:text-left">
            {/* <img
            src="https://cdn.dribbble.com/users/2400293/screenshots/14192537/media/769c67dc70df1e693f2589dd82619541.png"
            alt="app"
            className="max-w-xs mb-6"
          /> */}
            <div className="mb-3">
              <FloatingPhone />
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-dark mb-2">
              Download the Tiranga Express App
            </h2>
            <p className="text-secondary max-w-md mb-4">
              Fill your shifting details, check quotations within 5 - 10
              minutes, and see company reviews & ratings.
            </p>

            <div className="flex items-center w-full max-w-md mb-4">
              <span className="bg-white text-dark px-4 py-2 rounded-l border border-r-0 border-gray-300">
                +91
              </span>
              <input
                type="text"
                placeholder="Enter Mobile Number"
                className="flex-1 py-2 px-4 rounded-r border border-gray-300 focus:outline-none"
              />
              <button className="ml-4 bg-primary text-white px-4 py-2 rounded hover:bg-accent transition">
                Get App Link
              </button>
            </div>

            <a
              href="https://play.google.com/store"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Google Play"
                className="h-10 mb-5"
              />
            </a>
          </div>
        </div>
      </section>
      <AnimatePresence>
        {showModal && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className=" w-full  p-6 md:p-8 relative  overflow-y-auto"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
            >
              <AppointmentForm />
              <button
                onClick={handleToggleModal}
                className="absolute top-3 right-4 text-3xl text-white hover:text-red-500"
              >
                &times;
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default AppointmentAndAppDownload;
